import { Fragment, useState } from "react";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import DetailsPopup from "../DetailsPopup";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ArchiveIcon from "@material-ui/icons/Archive";
import CurrentUsageHistory from "./CurrentUsageHistory";
import ArchiveUsageHistory from "./ArchiveUsageHistory";

const UsageHistory = (props) => {
  const [query, setQuery] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [dataForModal, setDataForModal] = useState(null);
  const [historyType, setHistoryType] = useState("current");

  const handleArchiveHistory = () => {
    setQuery(null);
    setHistoryType("archive");
  };

  const handleCurrentHistory = () => {
    setQuery(null);
    setHistoryType("current");
  };

  const downloadCsv = () => {
    var data = [];
    var rows = document.querySelectorAll("table tr");

    for (var i = 0; i < rows.length; i++) {
      var row = [],
        cols = rows[i].querySelectorAll("td, th");

      for (var j = 0; j < cols.length; j++) {
        if (j < 2) {
          row.push(cols[j].innerText);
        }
        if (j === 2) {
          row.push(cols[j].innerText + " " + cols[j + 1].innerText);
        }
      }

      data.push(row.join(","));
    }

    downloadCSVFile(data.join("\n"), "1");
  };

  function downloadCSVFile(csv, filename) {
    var csv_file, download_link;

    csv_file = new Blob([csv], { type: "text/csv" });

    download_link = document.createElement("a");

    download_link.download = filename;

    download_link.href = window.URL.createObjectURL(csv_file);

    download_link.style.display = "none";

    document.body.appendChild(download_link);

    download_link.click();
  }

  const handleShowDetails = (data) => {
    setDataForModal(data);
    setModalVisible(true);
  };

  return (
    <Fragment>
      <div
        id="usages__history"
        class="col s12 bg-gray-light p-0 active scrollable_table__height__calc"
      >
        <div class="white radius-10 usage_history_top d-flex align-items-center justify-content-between px-3 mt-3">
          <div className="billing__archive__package">
            {historyType === "current" && (
              <div
                className="billing__archive__package__inner"
                onClick={handleArchiveHistory}
              >
                <ArchiveIcon />
                Archive History
              </div>
            )}

            {historyType === "archive" && (
              <div
                className="billing__archive__package__inner"
                onClick={handleCurrentHistory}
              >
                <AccessTimeIcon />
                Current History
              </div>
            )}
          </div>
          <div class="usage_search_field">
            <input
              type="text"
              class="radius-5 common__input__field pl-3 m-0"
              placeholder="Search"
              value={query || ""}
              onChange={(e) => setQuery(e.target.value)}
            />
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
                fill="#3C7EF3"
              ></path>
            </svg>
          </div>
        </div>
        <p style={{ display: "none" }} onClick={() => downloadCsv()}>
          Download
        </p>

        {historyType === "current" && (
          <CurrentUsageHistory
            query={query}
            onShowDetails={handleShowDetails}
          />
        )}
        {historyType === "archive" && (
          <ArchiveUsageHistory
            query={query}
          />
        )}
      </div>
      {modalVisible && (
        <DetailsPopup
          handleClose={() => {
            setModalVisible(false);
            setDataForModal(null);
          }}
          data={dataForModal}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.billingReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UsageHistory);
